<template>
  <div>
    <div class="handle">
      <el-button @click="batchDelete" :disabled="checkArray.length === 0"
        >批量移除</el-button
      ><el-button
        type="primary"
        @click="managePersons"
        >添加学员</el-button>
    </div>
    <Table @selection-change="selectChange" :data="currentPersons" />
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="persons.length"
      background
      hide-on-single-page
    />
    <person-manage
      @addSucceed="didAddUser"
      :defaultCheckedKeys="persons"
      :showPersonManage="showPersonManage"
      v-if="showPersonManage.flag"
      @closeManage="closeManage"
    />
  </div>
</template>

<script>
import Table from "./table.js";
import vue from "@/main.js";
import PersonManage from "./personManage";
import { Confirm } from "@/components/Confirm";
export default {
  inject: ["form"],
  components: {
    Table,
    PersonManage,
  },
  data() {
    return {
      checkArray: [],
      persons: [],
      currentPage: 1,
      currentSize: 10,
      showPersonManage: { flag: false },
      currentPersons: [],
    };
  },
  methods: {
    closeManage() {
      this.showPersonManage = { flag: false };
    },
    // 系统用户：显示名单管理
    managePersons() {
      this.showPersonManage = { flag: true };
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
     // 系统用户：名单管理
    didAddUser(persons) {
      this.showPersonManage = { flag: false };
      this.persons = persons;
      // this.form.messageForm.mqUserType === 0
      //   ? (this.persons = persons)
      //   : this.persons.splice(0, 0, persons);
      this.getCurrentPersons();
    },
    getCurrentPersons() {
      this.currentPersons =  this.persons.slice(
        this.currentSize * (this.currentPage - 1),
        this.currentSize * this.currentPage
      );
    },
    handleSizeChange(size) {
      this.currentSize = size;
      this.getCurrentPersons();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCurrentPersons();
    },
    // 批量删除人员
    async batchDelete() {
      const text = "确定删除该人员吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        // 批量删除
        let arrayDifference = (a, b) => {
          // 差集 a - b
          let clone = a.slice(0); // clone = a
          for (let i = 0; i < b.length; i++) {
            let temp = b[i];
            for (var j = 0; j < clone.length; j++) {
              if (temp === clone[j]) {
                clone.splice(j, 1); // remove clone[j]
              }
            }
          }
          return clone;
        };
        let filterData = (array) => {
          // 去重
          return Array.from(new Set(array));
        };
        this.persons = filterData(
          arrayDifference(this.persons, this.checkArray)
        );
        this.getCurrentPersons();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
